import { useEffect, useState } from "react";
import customAxios from "../../../../utils/customAxios";
import setAuthToken from "../../../../utils/setAuthToken";
import { mapRequestToRow } from "../utils";

const useModificationRequests = (params) => {
  const [rows, setRows] = useState([]);
  const [isLoadingRows, setIsLoadingRows] = useState(false);
  const [requestError, setRequestError] = useState("");
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchRequests = async () => {
        setIsLoadingRows(true);
        setRequestError("");

        try {
          if (localStorage.token) {
            setAuthToken(localStorage.token);
          }

          // Build query string from params
          const query = new URLSearchParams({
            sortBy: params.sortBy || 'asc',
            search: params.search || '',
            page: params.page || 1,
            limit: params.limit || 10,
            orderBy: params.orderBy || '_id',
            disableCalculateTotal: true,
            draw: params.draw || 0,
            id: params.id || '',
            startDate: params.startDate || '',
            endDate: params.endDate || '',
            status: params.status?.value || '',
            userType: params.userType?.value || '',
            responseBy: params.responseBy?.value || '',
            includeAdminEdit: false
          }).toString();

          const response = await customAxios.get(`/api/admin/request-change-booking?${query}`);
          const responseData = response?.data?.data || {};
          const responseRows = responseData.data || [];
          const mappedRows = responseRows.map(mapRequestToRow);
          setRows(mappedRows);
          setTotal(responseData.recordsFiltered || 0);
          setHasMore(!!responseData.hasMore);
        } catch (error) {
          setRows([]);
          setTotal(0);
          setRequestError(error?.response?.data?.msg || "Failed to load modification requests.");
        } finally {
          setIsLoadingRows(false);
        }
      };

      fetchRequests();
    }, 500);

    return () => clearTimeout(timer);
  }, [
    params.sortBy,
    params.search,
    params.page,
    params.limit,
    params.orderBy,
    params.disableCalculateTotal,
    params.draw,
    params.id,
    params.startDate,
    params.endDate,
    params.status,
    params.userType,
    params.responseBy,
    params.requestType,
  ]);

  return {
    rows,
    isLoadingRows,
    requestError,
    total,
    hasMore,
  };
};

export default useModificationRequests;
